import React, { useContext, useState } from 'react'
import MyAccountRemindersUI from '@interflora/ui-components/build/components/MyAccountReminders/MyAccountReminders'
import { useMutation, useQuery } from '@apollo/client'
import {
  GET_CUSTOMER_AVAILABLE_REMINDER_MONTHS,
  GET_MY_ACCOUNT_REMINDERS_LIST,
  SAVE_OCCASION_REMINDERS,
} from 'graphql/queries'
import { SiteContext, formatAddEditOccasionValues } from '@interflora/ui-components/build/utils/common'
import { AddEditOccasionValues, HandleSubmit, ReminderProps } from '@interflora/ui-components/build/common/props'
import _get from 'lodash-es/get'
import AnalyticsContext from 'context/AnalyticsContext'
import { useLoaded } from '@interflora/ui-components'

type GetOccasionReminderProps = {
  occasionReminders: ReminderProps[]
  count: number
}

const MyAccountReminders = (props: object) => {
  const { getCustomer } = useContext(SiteContext)
  const customerId = getCustomer?.data?.customer?.id
  const [reminders, setReminders] = useState<ReminderProps[]>()
  const [remindersTotalCount, setTotalRemindersCount] = useState<number>(0)
  const Analytics = useContext(AnalyticsContext)
  /** get customer's upcoming threee reminders */
  const { refetch: reminderRefetch, loading } = useQuery<{ getMyOccasionReminders: GetOccasionReminderProps }>(
    GET_MY_ACCOUNT_REMINDERS_LIST,
    {
      variables: { input: { page: 1, pageSize: 3 } },
      onCompleted: (data) => {
        if (data?.getMyOccasionReminders?.occasionReminders) {
          setReminders(data.getMyOccasionReminders.occasionReminders)
        }
        setTotalRemindersCount(data?.getMyOccasionReminders?.count || 0)
      },
      fetchPolicy: 'network-only',
      ssr: false,
      skip: !customerId,
    }
  )

  /** get occasions total reminders count and available months*/
  const { refetch: totalRemindersRefetch } = useQuery(GET_CUSTOMER_AVAILABLE_REMINDER_MONTHS, {
    skip: loading || !reminders?.length || !customerId,
    onCompleted: (data) => {
      setTotalRemindersCount(data?.getOccasionReminderAvailableMonths?.totalCount || 0)
    },
    fetchPolicy: 'network-only',
    ssr: false,
  })

  const [addNewReminderMutation] = useMutation(SAVE_OCCASION_REMINDERS)

  const addNewReminder: HandleSubmit<AddEditOccasionValues> = async (values) => {
    try {
      const response = await addNewReminderMutation({
        variables: { input: formatAddEditOccasionValues(values) },
      })
      Analytics.occasions([values.occasion], 'My Account')
      reminderRefetch().then(({ data }) => {
        setReminders(data.getMyOccasionReminders?.occasionReminders)
      })
      totalRemindersRefetch().then(({ data }) => {
        setTotalRemindersCount(data?.getOccasionReminderAvailableMonths?.totalCount || 0)
      })
      return response
    } catch (error) {
      const errMsg = _get(error, ['graphQLErrors', 0, 'message'])
      throw new Error(errMsg ?? 'There was a problem. Please try again')
    }
  }
  useLoaded(props)

  return (
    <MyAccountRemindersUI
      addNewReminder={addNewReminder}
      reminders={reminders}
      remindersTotalCount={remindersTotalCount}
    />
  )
}

export default MyAccountReminders
